import * as angular from "angular";
import {IController} from "angular";
import * as _ from "lodash";
import {Reminder} from "../../models/reminder.model";
import {ReminderSettings} from "../../../site-preferences/models/reminder-settings.model";

export class ReminderComponent implements IController {
  reminder: Reminder
  reminderSettings: ReminderSettings
  isEdit: boolean;
  isLoading: boolean;
  permissions: string;
  onSave: Function;
  onEdit: Function;
  onCancelEdit: Function;
  onDeleted: Function;

  public editedReminder: any;
  public today: any;

  constructor(private moment) {
    this.today = this.moment().startOf('day');
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.isEdit && !changes.isEdit.isFirstChange()) {
      this.editedReminder = this.isEdit ? this.reminder ? angular.copy(this.reminder) : {
        lastActionDate: this.today,
        nextActionDate: this.today
      } : undefined
    }
  }

  onReminderCreated(form) {
    if (form) {
      form.$setSubmitted(true);
      if (form.$valid) {
        this.onSave({reminder: this.editedReminder, settingsId: this.reminderSettings.id})
      }
    }
  }

  onLastActionDateChanged(selectedDate) {
    if (_.isUndefined(selectedDate)) {
      _.unset(this.editedReminder, 'lastActionDate');
    } else {
      _.set(this.editedReminder, 'lastActionDate', selectedDate)
    }
  }

  onNextActionDateChanged(selectedDate) {
    if (_.isUndefined(selectedDate)) {
      _.unset(this.editedReminder, 'nextActionDate');
    } else {
      _.set(this.editedReminder, 'nextActionDate', selectedDate)
    }
  }

}

angular
  .module('bringoz.admin.commons')
  .component('reminder', {
    bindings: {
      reminder: '<?',
      reminderSettings: '<',
      isEdit: '<',
      isLoading: '<',
      permissions: '<',
      onSave: '&',
      onEdit: '&',
      onCancelEdit: '&',
      onDeleted: '&'
    },
    template: require('./reminder.html').default,
    controller: ReminderComponent
  });
